import { ComponentProps, FC } from 'react';

import { SvgIcon } from './SvgIcon';

export const ChevronLeft: FC<ComponentProps<typeof SvgIcon>> = props => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8.80822 13.3412C9.1998 13.7307 9.83296 13.729 10.2224 13.3374C10.6119 12.9458 10.6102 12.3127 10.2186 11.9232L8.80822 13.3412ZM4.48647 7.6322L3.78127 6.9232C3.59257 7.11089 3.48647 7.36605 3.48647 7.6322C3.48647 7.89835 3.59257 8.15352 3.78127 8.34121L4.48647 7.6322ZM10.2186 3.34121C10.6102 2.95173 10.6119 2.31857 10.2224 1.927C9.83296 1.53543 9.1998 1.53372 8.80822 1.9232L10.2186 3.34121ZM10.2186 11.9232L5.19168 6.9232L3.78127 8.34121L8.80822 13.3412L10.2186 11.9232ZM5.19168 8.34121L10.2186 3.34121L8.80822 1.9232L3.78127 6.9232L5.19168 8.34121Z" />
  </SvgIcon>
);
